import type { ProjectItem } from '@customink/project-service-types';
import { atom } from 'jotai';

export type ModalSource = 'initial_load' | 'alert_link' | 'edit_sizes_link';

export type ModalState = {
  designCid: string;
  source: ModalSource;
  size?: string;
  projectItemId?: ProjectItem['id'];
};

export const modalStateAtom = atom<ModalState | null>(null);
